var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13394",
    "data-name": "Rectangle 13394",
    width: 6,
    height: 9.618,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Drag_Drop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drag_Drop",
    "data-name": "Drag & Drop",
    clipPath: "url(#clip-Drag_Drop)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20368",
    "data-name": "Group 20368",
    transform: "translate(2 0.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20367",
    "data-name": "Group 20367",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33354",
    "data-name": "Path 33354",
    d: "M98.2,1.188a1.205,1.205,0,0,1-1.2,1.215A1.224,1.224,0,0,1,95.8,1.157a1.2,1.2,0,0,1,2.391.032",
    transform: "translate(-92.205 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33355",
    "data-name": "Path 33355",
    d: "M1.188,96.188A1.182,1.182,0,0,1,2.4,97.483a1.233,1.233,0,0,1-1.212,1.1A1.218,1.218,0,0,1,0,97.317a1.179,1.179,0,0,1,1.186-1.129",
    transform: "translate(-0.002 -92.571)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33356",
    "data-name": "Path 33356",
    d: "M97,96.182a1.183,1.183,0,0,1,1.213,1.291A1.234,1.234,0,0,1,97,98.575a1.219,1.219,0,0,1-1.187-1.26A1.18,1.18,0,0,1,97,96.182",
    transform: "translate(-92.213 -92.565)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33357",
    "data-name": "Path 33357",
    d: "M1.182,192.182A1.183,1.183,0,0,1,2.4,193.473a1.234,1.234,0,0,1-1.208,1.1A1.219,1.219,0,0,1,0,193.316a1.18,1.18,0,0,1,1.182-1.133",
    transform: "translate(0 -184.958)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33358",
    "data-name": "Path 33358",
    d: "M98.2,193.2A1.205,1.205,0,0,1,97,194.4a1.223,1.223,0,0,1-1.192-1.256,1.2,1.2,0,0,1,2.391.049",
    transform: "translate(-92.206 -184.786)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33359",
    "data-name": "Path 33359",
    d: "M1.188.19A1.181,1.181,0,0,1,2.4,1.486a1.227,1.227,0,0,1-1.213,1.1A1.216,1.216,0,0,1,0,1.332,1.181,1.181,0,0,1,1.188.19",
    transform: "translate(0 -0.18)",
    fill: "#ccc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDrop);
export default __webpack_public_path__ + "static/media/Drag & Drop.bb11ab34a65c5f0518b6de31d5c66831.svg";
export { ForwardRef as ReactComponent };